import useDataFetcher from '~/components/useDataFetcher';

interface IFnolAiPermissions {
  isAllowedForUser: boolean;
}

interface FnolPermissionResponse {
  is_allowed: boolean;
}

export const useFnolAiPermissions = (): IFnolAiPermissions => {
  const { data: fnolPermission } = useDataFetcher<FnolPermissionResponse>('/api/v1/fnol_inbox/inbox/is_allowed', {});

  return {
    isAllowedForUser: !!fnolPermission?.is_allowed,
  };
};
